module.exports = __webpack_public_path__ + "img/step41_b_printer_power_open_multisheet_tray_remove_tapes.a7081711.png";